<template>
    <div
            class="modal fade"
            id="sys_search_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">高级搜索</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <form id="sys_dlg_search_form" role="form" class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-2 control-label">代维公司：</label>
                            <div class="col-sm-4">
                                <select id="search_proxymaintain" class="chosen-select2">
                                    <option value>&nbsp;</option>
                                </select>
                            </div>

                            <label class="col-sm-2 control-label">导入批次：</label>
                            <div class="col-sm-4">
                                <select id="search_branch" class="chosen-select2">
                                    <option value>&nbsp;</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">任务状态：</label>
                            <div class="col-sm-4">
                                <select id="search_status" class="chosen-select2">
                                    <option value>&nbsp;</option>
                                    <option value="处理中">处理中</option>
                                    <option value="已完成">已完成</option>
                                </select>
                            </div>
                            <label class="col-sm-2 control-label">任务类型：</label>
                            <div class="col-sm-4">
                                <select id="search_type" class="chosen-select2">
                                    <option value>&nbsp;</option>
                                    <option value="非共站">非共站</option>
                                    <option value="共站">共站</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" data-dismiss="modal" class="btn btn-primary">搜索</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    mounted: function () {
      var self = this
      $('.chosen-select2')
        .chosen({
          disable_search_threshold: 10,
          disable_search: true,
          width: '100%'
        })
        .change(function () {
          //self.data.stst_comm = $(".chosen-select").val();
          // console.log(self.data.stst_comm);
        })
    },
    methods: {}
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/approvalCenter/advancedsearch.vue